export const ContactStateEnum = {
  new: 'new',
  resumed: 'resumed',
};
export type ContactStateEnum =
  (typeof ContactStateEnum)[keyof typeof ContactStateEnum];
